module.exports = __webpack_public_path__ + "img/content.bb2c31e6.svg";